import { useMutation, useQueryClient } from '@tanstack/react-query'

import {
  ECampaignAgentAccessScope,
  TCampaign,
  TCampaignError,
} from '~/features/campaigns/models'
import { queryKeys } from '~/features/campaigns/utils'
import { EHttpService, EServerPath } from '~/models/api'
import HttpService from '~/services/http'
import pathBuilder from '~/utils/api'

export type TCloneCampaignPayload = {
  campaignId: string
  currentAgentId: string
  campaignName: string
  agentIds: string[]
  agentAccessScope?: ECampaignAgentAccessScope
  cloneJunctionContent: boolean
}

const cloneCampaign = async ({
  campaignId,
  campaignName,
  agentIds,
  agentAccessScope,
  cloneJunctionContent,
}: TCloneCampaignPayload) => {
  return HttpService.post<TCampaign | TCampaignError>(
    {
      path: pathBuilder(EServerPath.campaignClone, { id: campaignId }),
      payload: {
        campaignName,
        agentIds,
        cloneJunctionContent,
        ...(agentAccessScope ? { agentAccessScope } : {}),
      },
    },
    EHttpService.internal,
  ).then((res) => (res.data ? res.data : res))
}

const useCloneCampaign = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: TCloneCampaignPayload) => cloneCampaign(payload),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.campaignsBase(variables.currentAgentId),
      })
    },
  })
}

export default useCloneCampaign
